import * as themes from "./themes";

export default function themeChanger(themeName) {
  let currentObject = themes.default[themeName];

  clearClassListAndBodyBg();

  if (!currentObject) {
    // force claro (none) if unknown theme name:
    return;
  }

  insertClassListAndBodyBg(currentObject);
}

function insertClassListAndBodyBg(currentObject) {
  let themeTitle = currentObject.title;
  let propertiesObjects = getObjectWithoutParents(currentObject.styles);
  let propertiesList = getAsAList(propertiesObjects);
  let className = `mdn-Theme--${themeTitle}`;

  if (themeTitle === "claro") return;
  document.documentElement.classList.add(`mdn-Theme`, className);

  let styles = `body { background-color: ${currentObject.bodyStyle.backgroundColor}; }\n`;
  styles += `.${className} {`;
  styles += propertiesList.join(";");
  styles += `}`;

  let styleTag = document.createElement("style");
  styleTag.id = "mdn-Theme-style";
  styleTag.innerText = styles;

  document.body.appendChild(styleTag);
}

function getAsAList(object) {
  let finalArray = [];
  for (const variable in object) {
    finalArray.push(`${variable}:${object[variable]}`);
  }
  return finalArray;
}

function clearClassListAndBodyBg() {
  document.documentElement.classList.remove(`mdn-Theme`);
  let themeStyleTag = document.getElementById(`mdn-Theme-style`);
  themeStyleTag && themeStyleTag.parentNode.removeChild(themeStyleTag);
  for (const variable in themes.default) {
    document.documentElement.classList.remove(`mdn-Theme--${variable}`);
  }
}

function getObjectWithoutParents(currentObject, finalObject={}) {
  finalObject = finalObject || {};
  for (const key in currentObject) {
    if (key.match(/^--theme/)) {
      finalObject[key] = currentObject[key];
    } else {
      finalObject = {
        ...getObjectWithoutParents(currentObject[key], finalObject)
      };
    }
  }
  return finalObject;
}

export { themeChanger };
